import React, { useCallback, useMemo } from 'react';
import { Button, rem } from 'design-system';
import { useAppSelector } from 'store/hooks';
import { StyleSheet } from 'react-native';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { selectActiveTier, selectAnnualDiscountPercentage } from '../selectors';
import { isPremiumTier } from '../entities';
import { selectUserOrganisation } from '../selectors/tier';
import { keepYearlyText, switchPeriodToYearlyText } from '../annualDiscount';
const SwitchToYearlyButton = ({ outline, withContainer, showIfNotRenewing = false, extraStyle, }) => {
    const activeTier = useAppSelector(selectActiveTier);
    const annualDiscount = useAppSelector((store) => selectAnnualDiscountPercentage(store, activeTier));
    const emmaProStatus = useAppSelector((store) => store.user.user.emmaProStatus);
    const employer = useAppSelector(selectUserOrganisation);
    const isSeatPlan = 'type' in emmaProStatus &&
        ((emmaProStatus.type === 'employee' && !!employer) ||
            emmaProStatus.type === 'family');
    const onPress = useCallback(() => {
        UnavailableOnWebModal.show('emma://manage-plan', 'Manage plan');
    }, []);
    const hideButton = useMemo(() => !isPremiumTier(activeTier) ||
        isSeatPlan ||
        emmaProStatus.autoRenewPeriod === 'yearly' ||
        (!(!emmaProStatus.autoRenewing &&
            emmaProStatus.period === 'monthly' &&
            showIfNotRenewing) &&
            emmaProStatus.tier !== emmaProStatus.autoRenewTier), [
        activeTier,
        emmaProStatus.autoRenewPeriod,
        emmaProStatus.autoRenewing,
        emmaProStatus.autoRenewTier,
        emmaProStatus.period,
        emmaProStatus.tier,
        isSeatPlan,
        showIfNotRenewing,
    ]);
    if (hideButton)
        return null;
    const buttonTitle = emmaProStatus.period === 'yearly' &&
        emmaProStatus.autoRenewPeriod === 'monthly'
        ? keepYearlyText(annualDiscount)
        : switchPeriodToYearlyText(annualDiscount);
    return (<Button {...(outline ? { brandBorder: true } : { brandLight: true })} square title={buttonTitle} onPress={onPress} containerStyle={[
            withContainer ? styles.container : undefined,
            withContainer
                ? { marginTop: emmaProStatus.autoRenewing ? rem(8) : rem(-4) }
                : undefined,
            extraStyle,
        ]}/>);
};
const styles = StyleSheet.create({
    container: {
        marginBottom: rem(16),
        marginHorizontal: rem(16),
    },
});
export default SwitchToYearlyButton;
